import { render, staticRenderFns } from "./TongueTemplate.vue?vue&type=template&id=219ea306&"
import script from "./TongueTemplate.vue?vue&type=script&lang=js&"
export * from "./TongueTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports